import { QueryClient } from '@tanstack/vue-query'
const myClient = new QueryClient()
export function useQueryClient(): QueryClient {
   return myClient
}
